import React from "react";

// MUI Components:
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";


// Custom Components:
import Carousal from "../../CustomCarousal/Carousal";
import ObjectInfoBar from "../../ObjectInfoBar/ObjectInfoBar";


// context
import { useFavorites, useFavoritesDispatch } from "../../../../Context/FavoritesContext";


function Object({oObject,onObjDetailPress}) {

  const favoritesList   =  useFavorites(),
        favListDispatch =  useFavoritesDispatch();

  
  // const onFavoriteClick = (oEvent,currObjID) => {

  //     oEvent.preventDefault();

  //     let bItemExist = favoritesList.find(oItem => oItem.objID === currObjID );

  //     if (!bItemExist) { favListDispatch({ type: 'add', objID:  currObjID }); }

  //     if(bItemExist)  {  favListDispatch ({ type: 'delete', objID:  currObjID  }); }
  // }

    return(
          <Box sx={{ 
                    display:'flex',
                    flexDirection:'column', 
                    marginTop:'1rem', 
                    marginBottom:'1rem',
                    marginLeft:'0.5',
                    marginRight:'0.5rem',
                    backgroundColor:'white',
                    borderRadius:'1rem'
                  }}>
            <Box>
              {/* Note: Image hight to be passed based on screen size 250*/}
              <Carousal
                currObjID={oObject._id}   
                currObjcetImages={oObject.mediaSmall}
                sImageHight={250}
                showMoreImages={false}
                showNavArrow={false}/> 
            </Box>
            
            <Box >
              <ObjectInfoBar 
                  oObject={oObject}
                  onObjDetailPress={onObjDetailPress}/>
            </Box>
         </Box>
    )
}

export default Object;